export class CreateFeaturedTenantCategoryDto {
  categoryId: string
}

export class SortOrderFeaturedTenantCategoryDto {
  categoryIds: string[]
}